var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("PortfolioScenarioEditor", {
        attrs: { viewModel: _vm.portfolioScenarioEditor },
      }),
      _vm._v(" "),
      _c("PortfolioNavigation", {
        attrs: { workspaceId: _vm.workspaceId, projectId: _vm.tchProjectId },
      }),
      _vm._v(" "),
      _vm.rm
        ? _c(
            "div",
            {
              staticClass: "container",
              staticStyle: { "margin-top": "80px", "padding-top": "40px" },
            },
            [
              _c("div", { staticClass: "row" }, [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-6 text-right align-self-end" },
                  [
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "sanitizedHref",
                            rawName: "v-sanitizedHref",
                            value: `/#/enterprise/planning/${_vm.rm.StrategyWorkspaceId}/${_vm.rm.StrategyId}`,
                            expression:
                              "`/#/enterprise/planning/${rm.StrategyWorkspaceId}/${rm.StrategyId}`",
                          },
                        ],
                        staticClass: "btn btn-outline-success",
                        staticStyle: { padding: "0.7em 2em" },
                      },
                      [_vm._v("Enterprise plans")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "dropdown d-inline" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-outline-secondary dropdown-toggle",
                          staticStyle: { padding: "0.7em 2em" },
                          attrs: { "data-toggle": "dropdown" },
                        },
                        [
                          _vm._v(
                            "\n                        Actions\n                    "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "dropdown-menu dropdown-menu-right dropdown-menu-scrollable",
                          attrs: { role: "menu" },
                        },
                        [
                          _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "sanitizedHref",
                                  rawName: "v-sanitizedHref",
                                  value: `/#/portfolio/import/${_vm.workspaceId}/${_vm.tchProjectId}`,
                                  expression:
                                    "`/#/portfolio/import/${workspaceId}/${tchProjectId}`",
                                },
                              ],
                              staticClass: "dropdown-item",
                            },
                            [_vm._v("Import business cases")]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "dropdown-item",
                              on: {
                                click:
                                  _vm.handleExportAllActiveProjectPlansCommand,
                              },
                            },
                            [_vm._v("Export business cases")]
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("hr", {
                staticStyle: { "border-color": "#bbb", margin: "20px 0 60px" },
              }),
              _vm._v(" "),
              _vm.rm.NotConnectedScenarios.length
                ? _c(
                    "table",
                    { staticClass: "table table-bordered table-hover mb-3" },
                    [
                      _c(
                        "tbody",
                        _vm._l(_vm.rm.NotConnectedScenarios, function (s) {
                          return _c(
                            "tr",
                            { key: s.Id, staticClass: "table-danger" },
                            [
                              _c("td", [
                                _vm._v(
                                  "\n                        " + _vm._s(s.Name)
                                ),
                                _c("br"),
                                _vm._v(" "),
                                _c("small", { staticClass: "text-muted" }, [
                                  _vm._v(
                                    "Created: " +
                                      _vm._s(_vm.formatDate(s.CreatedDate)) +
                                      ", " +
                                      _vm._s(_vm.formatTime(s.CreatedDate)) +
                                      " by " +
                                      _vm._s(s.CreatedByName)
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticClass: "text-center align-middle",
                                  staticStyle: { width: "150px" },
                                },
                                [
                                  _c("div", { staticClass: "btn-group" }, [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-outline-secondary dropdown-toggle",
                                        attrs: {
                                          type: "button",
                                          "data-toggle": "dropdown",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                Connect\n                            "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "dropdown-menu dropdown-menu-right",
                                      },
                                      _vm._l(
                                        _vm.rm.CorporateScenarios,
                                        function (cs) {
                                          return _c(
                                            "a",
                                            {
                                              key: cs.Id,
                                              staticClass: "dropdown-item",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleConnectToCorporateScenarioCommand(
                                                    s,
                                                    cs
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                    " +
                                                  _vm._s(cs.Name) +
                                                  "\n                                "
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                {
                                  staticClass: "text-center align-middle",
                                  staticStyle: { width: "70px" },
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-outline-secondary",
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleDeletePortfolioScenarioCommand(
                                            s.Id
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fa-regular fa-trash-can",
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          )
                        }),
                        0
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.rm.CorporateScenarios, function (cs) {
                return _c(
                  "table",
                  {
                    key: cs.Id,
                    staticClass: "table table-bordered table-hover",
                  },
                  [
                    _c(
                      "tbody",
                      [
                        _c("tr", { staticClass: "table-secondary" }, [
                          _c("td", { staticStyle: { width: "60px" } }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-outline-secondary",
                                on: {
                                  click: function ($event) {
                                    cs.IsCollapsed = !cs.IsCollapsed
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  class: [
                                    "fa",
                                    cs.IsCollapsed
                                      ? "fa-chevron-down"
                                      : "fa-chevron-up",
                                  ],
                                }),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _c(
                              "span",
                              {
                                staticClass: "badge badge-primary float-right",
                              },
                              [_vm._v("Enterprise plan")]
                            ),
                            _vm._v(" "),
                            _c("small", { staticClass: "text-muted" }, [
                              _vm._v(
                                _vm._s(_vm.formatDate(cs.StartDate)) +
                                  " - " +
                                  _vm._s(_vm.formatDate(cs.EndDate))
                              ),
                            ]),
                            _c("br"),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                directives: [
                                  {
                                    name: "sanitizedHref",
                                    rawName: "v-sanitizedHref",
                                    value: `/#/enterprise-plan/portfolios/${_vm.rm.StrategyWorkspaceId}/${_vm.rm.StrategyId}/${cs.Id}`,
                                    expression:
                                      "`/#/enterprise-plan/portfolios/${rm.StrategyWorkspaceId}/${rm.StrategyId}/${cs.Id}`",
                                  },
                                ],
                                staticClass: "text-primary",
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(cs.Name) +
                                    "\n                        "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            cs.IsCollapsed === false
                              ? _c("div", [
                                  _c("small", [_vm._v(_vm._s(cs.Description))]),
                                ])
                              : _vm._e(),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm._l(cs.Scenarios, function (ps) {
                          return cs.IsCollapsed === false
                            ? _c("tr", { key: ps.Id }, [
                                _c("td", [
                                  _c("div", { staticClass: "dropdown" }, [
                                    _vm._m(1, true),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "dropdown-menu" },
                                      [
                                        _c(
                                          "a",
                                          {
                                            directives: [
                                              {
                                                name: "sanitizedHref",
                                                rawName: "v-sanitizedHref",
                                                value: `/#/portfolio-plan/projects/${_vm.workspaceId}/${_vm.tchProjectId}/${ps.Id}`,
                                                expression:
                                                  "`/#/portfolio-plan/projects/${workspaceId}/${tchProjectId}/${ps.Id}`",
                                              },
                                            ],
                                            staticClass: "dropdown-item",
                                          },
                                          [_vm._v("View")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticClass: "dropdown-item",
                                            on: {
                                              click: function ($event) {
                                                return _vm.showPortfolioScenarioEditor(
                                                  ps
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("Settings")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticClass: "dropdown-item",
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleClonePortfolioScenarioCommand(
                                                  ps
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("Clone")]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass: "dropdown-divider",
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          {
                                            staticClass: "dropdown-item",
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleDeletePortfolioScenarioCommand(
                                                  ps.Id
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("Delete")]
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "badge badge-secondary float-right",
                                    },
                                    [_vm._v("Portfolio plan")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      directives: [
                                        {
                                          name: "sanitizedHref",
                                          rawName: "v-sanitizedHref",
                                          value: `/#/portfolio-plan/projects/${_vm.workspaceId}/${_vm.tchProjectId}/${ps.Id}`,
                                          expression:
                                            "`/#/portfolio-plan/projects/${workspaceId}/${tchProjectId}/${ps.Id}`",
                                        },
                                      ],
                                      staticClass: "text-primary",
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(ps.Name) +
                                          "\n                        "
                                      ),
                                    ]
                                  ),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("small", { staticClass: "text-muted" }, [
                                    _vm._v(
                                      "Created: " +
                                        _vm._s(_vm.formatDate(ps.CreatedDate)) +
                                        ", " +
                                        _vm._s(_vm.formatTime(ps.CreatedDate)) +
                                        " by " +
                                        _vm._s(ps.CreatedByName)
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _c("small", [
                                      _vm._v(_vm._s(ps.Description)),
                                    ]),
                                  ]),
                                ]),
                              ])
                            : _vm._e()
                        }),
                        _vm._v(" "),
                        cs.IsCollapsed === false
                          ? _c("tr", [
                              _c(
                                "td",
                                {
                                  staticClass: "text-center",
                                  attrs: { colspan: "2" },
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-secondary",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.showPortfolioScenarioCreator(
                                            cs.Id
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            Create portfolio plan\n                        "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]
                )
              }),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-lg-6" }, [
      _c(
        "h1",
        {
          staticStyle: {
            "font-size": "2em",
            "font-weight": "300",
            color: "#33475b",
            margin: "0",
          },
        },
        [_vm._v("Planning")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "button",
      {
        staticClass: "btn btn-outline-secondary",
        attrs: { type: "button", "data-toggle": "dropdown" },
      },
      [_c("i", { staticClass: "fa-solid fa-ellipsis" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }